// extracted by mini-css-extract-plugin
module.exports = {"advertiserDisclosure":"Article-module--advertiserDisclosure--1mhlQ","authorTag":"Article-module--authorTag--22dvk"};